import React, { useContext, useEffect, useState } from "react";
import Subheader from "../components/Subheader";
import { ThemeContext } from "../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import {
  addSellerTracking,
  deleteSellerTracking,
  fetchSellerTracking,
} from "../redux/slices/sellerTrackingSlice";
import { useCheckUserAuth } from "../utlis/useCheckUserAuth";
import CommonModal from "../components/CommonModal";

const spySearchModal = [
  { title: "SELLER-ID", value: "seller_id" },
  { title: "LAND", value: "locale" },
  { title: "TRACKING SEIT", value: "tracked_since" },
  { title: "PINGS 24H", value: "pings24hrs" },
];

const SellerTracking = ({ closeModal }) => {
  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const authStatus = useSelector((state) => state.sellerTracking.authStatus);
  useCheckUserAuth(authStatus);

  const sellerDetails = useSelector((state) => state.sellerTracking.seller);
  const tokens = useSelector((state) => state.sellerTracking.tokens);
  const [tutorialModal, setTutorialModal] = useState(false);
  const [sellerData, setSellerData] = useState([]);
  const [sellerName, setSellername] = useState("");
  const [sellerId, setSellerId] = useState("");
  const [error, setError] = useState("");
  const [issLoader, setIsLoader] = useState(false);

  useEffect(() => {
    setIsLoader(true);
    dispatch(fetchSellerTracking());
  }, []);

  useEffect(() => {
    if (sellerDetails && sellerDetails.tracked_seller) {
      setSellerData(sellerDetails.tracked_seller);
      setIsLoader(false);
    }
  }, [sellerDetails]);

  const handleAddSellerTracking = () => {
    if (!sellerName || !sellerId) {
      setError("Both fields are required");
      return;
    }

    const sellerTracking = {
      sellername: sellerName,
      sellerid: sellerId,
    };

    dispatch(addSellerTracking(sellerTracking));
    setSellername("");
    setSellerId("");
    setError("");
  };

  const handleSellerDelete = (seller) => {
    const sellerId = seller.seller_id;
    dispatch(deleteSellerTracking(sellerId));
  };

  const handleExportCsv = () => {
    if (!sellerData.length) return;

    const columns = [
      { title: "NICKNAME", value: "seller_name" },
      ...spySearchModal,
    ];

    const escapeCell = (value) => {
      const text = String(value ?? "");
      return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
    };

    const rows = [
      columns.map((col) => col.title).join(";"),
      ...sellerData.map((seller) =>
        columns.map((col) => escapeCell(seller[col.value])).join(";")
      ),
    ];

    // Semikolon + BOM: deutsches Excel erwartet ; als Trenner und
    // erkennt UTF-8 (Umlaute in Nicknames) nur mit BOM
    const blob = new Blob(["\uFEFF" + rows.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `seller-tracking-${new Date().toISOString().slice(0, 10)}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };
  const handlOpen = () => {
    setTutorialModal(true);
  };

  // Calculate the percentage of tokens used
  const totalTrackedSellers = sellerData.length;
  const availableTokens = tokens || 10; // Fallback to 10 if tokens is not available
  const tokenUsagePercentage =
    availableTokens > 0 ? (totalTrackedSellers / availableTokens) * 100 : 0;
  // Ensure percentage doesn't exceed 100%
  const cappedPercentage = Math.min(tokenUsagePercentage, 100);

  return (
    <div className="bg-background p-10 rounded-lg max-h-[700px] md:h-auto overflow-auto w-[360px] sm:w-[600px] md:w-[700px] lg:w-[800px]">
      <div className="bg-background mb-4 flex justify-between items-center">
        <div>
          <Subheader
            subtitle={<>
              Füge Namen und die Seller-ID ein um einen Verkäufer anzulegen ・
              <span className="text-primary ml-1" onClick={handlOpen}>
                Tutorial
              </span>
            </>}
          >
            Seller <em>Tracking</em>
          </Subheader>
        </div>

        <div
          onClick={closeModal}
          className="bg-secondary w-[30px] h-[30px] flex justify-center items-center cursor-pointer rounded absolute top-4 right-3"
        >
          <img
            src={
              theme === "dark"
                ? "/static/close-1.svg"
                : "/static/LightMode/close-2.svg"
            }
            width={15}
            className="float-right"
            alt="close"
          />
        </div>
      </div>

      <div className=" gap-4 pb-4 flex flex-wrap">
        <input
          type="text"
          className="w-[115px] placeholder:text-xs placeholder:text-center 
          placeholder:text-[#575656] placeholder:dark:text-[#d2d2d2] px-2 py-1 focus:outline-none border-[0.5px] 
          text-[#575656] dark:text-[#d2d2d2]
         rounded dark:!bg-[#121215]    dark:border-none  border-[#FFFFFF30]  bg-text text-textTitle 
        shadow-[0px_0px_5px_0px_#0000001A]
 "
          placeholder="Nickname"
          value={sellerName}
          onChange={(e) => setSellername(e.target.value)}
        />
        <input
          type="text"
          className="w-[115px] placeholder:text-xs placeholder:text-center  placeholder:text-[#575656] placeholder:dark:text-[#d2d2d2]
          border-[0.5px]
           dark:border-none rounded shadow-[0px_0px_5px_0px_#0000001A] dark:!bg-[#121215] 
          px-2 py-1 focus:outline-none b  bg-text text-[#575656] dark:text-[#d2d2d2] border-[#FFFFFF30]"
          placeholder="Seller-Id"
          value={sellerId}
          onChange={(e) => setSellerId(e.target.value)}
        />
        <button
          className="p-2 px-3 !text-[12px] font-semibold text-text tracking-wider
                bg-gradient-to-br from-primary to-main rounded-md"
          onClick={handleAddSellerTracking}
        >
          Hinzufügen
        </button>
        <span className="flex-1"></span>
        <button
          className="p-2 px-3 !text-[12px] font-semibold tracking-wider rounded-md
                border-[0.5px] border-borderBottom text-textTitle bg-background
                hover:border-primary disabled:opacity-40 disabled:hover:border-borderBottom"
          onClick={handleExportCsv}
          disabled={sellerData.length === 0}
        >
          <i className="bx bx-download mr-1 align-middle"></i>
          CSV Export
        </button>
      </div>
      {error && <p className="text-red-500 text-xs mb-3">{error}</p>}

      {/* Usage Indicator */}
      <div className="mb-4 p-3 rounded-lg bg-secondary/20 border border-borderBottom">
        <div className="flex justify-between items-center mb-2">
          <span className="text-textTitle text-sm font-medium">Nutzung</span>
          <span className="text-textTitle text-xs">
            {totalTrackedSellers} / {availableTokens} Seller
          </span>
        </div>
        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
          <div
            className="bg-gradient-to-r from-primary to-main h-2 rounded-full transition-all duration-300"
            style={{ width: `${cappedPercentage}%` }}
          ></div>
        </div>
        <div className="flex justify-between mt-1">
          <span className="text-xs text-gray-500">
            {Math.round(cappedPercentage)}% verwendet
          </span>
          <span className="text-xs text-gray-500">
            {availableTokens - totalTrackedSellers} verbleibend
          </span>
        </div>
      </div>

      {sellerData.length > 0 ? (
        <div className="grid grid-cols-1 gap-4 max-h-[400px] overflow-y-auto no-scrollbar md:w-auto mt-2">
          {sellerData.map((seller, index) => {
            return (
              <div
                key={index}
                className="card p-3 rounded dark:bg-[#07070b] m-1 bg-white border-[#2d2d2d66] dark:border-[0.5px] 
                 shadow-[0px_0px_5px_0px_#0000001A]
"
              >
                <img
                  src={
                    theme === "dark"
                      ? "/static/close-1.svg"
                      : "/static/LightMode/close-2.svg"
                  }
                  width={10}
                  className="float-right cursor-pointer"
                  onClick={() => handleSellerDelete(seller)}
                  alt="close"
                />

                <div className="text-textTitle cursor-pointer list-none">
                  <p
                    className="text-[18px] font-medium text-primary capitalize dark:text-[#59ffc6]"
                    id="title"
                  >
                    {seller.seller_name}
                  </p>
                </div>

                <div className="flex gap-3 flex-wrap mt-1">
                  {spySearchModal.map((item, index) => (
                    <div key={index} className="text-left">
                      <p className="subtitle !text-[11px] uppercase text-[#5F5E5E]">
                        {item.title}
                      </p>
                      <div className="rounded w-full text-center border-[1px] border-borderBottom shadow dark:!bg-[#121215]    dark:border-none ">
                        <p
                          className="p_detail 
                           dark:!bg-seller-dark  dark:bg-clip-text
                          pt-1 pb-1 px-3 !text-[12px]  w-auto dark:text-transparent text-black"
                          style={{
                            backgroundClip: theme === "light" && "text",
                          }}
                        >
                          {seller[item.value]}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex justify-center items-center my-3">
          {issLoader ? (
            <i className="animate-spin bx bx-loader-alt text-4xl text-primary"></i>
          ) : sellerData.length === 0 ? (
            <p className="text-textTitle">Noch keine Verkäufer angelegt</p>
          ) : null}
        </div>
      )}
      <CommonModal
        isOpen={tutorialModal}
        setIsOpen={() => setTutorialModal(false)}
        closeModal={closeModal}
      >
        <div className="bg-background text-center p-10 rounded-lg max-h-[700px] md:h-auto overflow-auto w-[360px] sm:w-[600px] md:w-[700px] lg:w-[800px]">
          <div
            onClick={() => setTutorialModal(false)}
            className="cursor-pointer bg-secondary w-[30px] h-[30px] flex justify-center items-center float-end rounded"
          >
            <img
              src={
                theme === "dark"
                  ? "/static/close-1.svg"
                  : "/static/LightMode/close-2.svg"
              }
              width={15}
              className="float-right"
              alt="close"
            />
          </div>

          <div className="flex flex-col gap-4">
            <h2 className="text-textTitle text-2xl mb-3 font-bold	">
              Wie füge ich neue Seller hinzu?
            </h2>
            <p className="text-textTitle text-base	">
              Um neue Seller hinzufügen benötigst du die Seller-ID und einen
              Nickname.
            </p>
            <p className="text-textTitle text-base	">
              Die Seller-ID findest du wenn du die Storefront des Verkäufers
              öffnest hier im Link
            </p>
          </div>
          <div className="bg-subModalBg  py-4 px-3 text-[22px] rounded-full my-5 ">
            <p className="text-textTitle">
              amazon.de/s?me=
              <span className="uppercase">
                <span className="text-primary">sellerid</span>
                &marketplaceid=a1pa689
              </span>
            </p>
          </div>
          <div>
            <div className="flex flex-col gap-4">
              <p className="text-textTitle">
                Du findest Sie am Anfang des Link und sie sieht z.B so aus
              </p>
              <p className="uppercase text-textTitle">ALVXHKURZ8FRL</p>
              <p className="text-textTitle ">
                Kopiere diese und füge Sie unter der Spalte Seller-ID ein,
              </p>
              <p className="text-textTitle">
                füge einen Nickname hinzu und drücke auf hinzufügen.
              </p>
            </div>
          </div>
        </div>
      </CommonModal>
    </div>
  );
};

export default SellerTracking;
